(function() {
  // Klaviyo form ID (from data-testid="klaviyo-form-TRABkq")
  const FORM_ID = 'TRABkq';

  function initKlaviyoFloatingLabels(form) {
    if (!form || form.dataset.klFloatingLabelsInit === 'true') return;
    form.dataset.klFloatingLabelsInit = 'true';

    // Grab all labels inside the Klaviyo reset wrapper in THIS form
    const labels = form.querySelectorAll('.kl-private-reset-css-Xuajs1 label[for]');

    labels.forEach(label => {
      const targetId = label.getAttribute('for');
      if (!targetId) return;

      const selector =
        '#' + (window.CSS && CSS.escape ? CSS.escape(targetId) : targetId);
      const field = form.querySelector(selector);
      if (!field) return;

      const updateLabelState = () => {
        const hasValue = field.value && field.value.trim() !== '';
        const isActive = document.activeElement === field;

        // RULES:
        // - On focus (click): add kl-move-up
        // - On blur: remove kl-move-up ONLY if empty
        // - If not empty: keep kl-move-up even when outclicked
        if (isActive || hasValue) {
          label.classList.add('kl-move-up');
        } else {
          label.classList.remove('kl-move-up');
        }
      };

      // Initial state (handles autofill / prefilled values)
      updateLabelState();

      field.addEventListener('focus', updateLabelState);
      field.addEventListener('blur', updateLabelState);
      field.addEventListener('input', updateLabelState);
      field.addEventListener('change', updateLabelState);
    });
  }

  // Listen for Klaviyo form load
  window.addEventListener('klaviyoForms', function(e) {
    const detail = e.detail || {};
    const { type, formId } = detail;

    // For embedded forms it's usually 'embedOpen'; popups can use 'open'
    if ((type === 'embedOpen' || type === 'open') && formId === FORM_ID) {
      // Let Klaviyo finish injecting DOM
      setTimeout(function() {
        const form = document.querySelector(
          'form[data-testid="klaviyo-form-' + FORM_ID + '"]'
        );
        if (!form) return;
        initKlaviyoFloatingLabels(form);
      }, 0);
    }
  });
})();